import { render, staticRenderFns } from "./StateroomDetailSuite.vue?vue&type=template&id=3b412da8&scoped=true"
import script from "./StateroomDetailSuite.vue?vue&type=script&lang=js"
export * from "./StateroomDetailSuite.vue?vue&type=script&lang=js"
import style0 from "./StateroomDetailSuite.vue?vue&type=style&index=0&id=3b412da8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b412da8",
  null
  
)

export default component.exports